module.exports = __webpack_public_path__ + "static/10_rot2-1-4452e378f3f166556e5a693e64119699.png";